module.exports = __webpack_public_path__ + "templates/restaurant.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/restaurant/templates/restaurant.html
// module id = N3jh
// module chunks = 1